var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hashtag.length > 0)?_c('h1',{staticClass:"hashtag"},[_vm._v(" "+_vm._s(_vm.hashtag)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }